export default __webpack_public_path__ + "media/components/Statistics/xlsx_icon-81ad54ee77aa70f2175e040122ace66e.png";